<table>
  <thead>
    <tr>
      @for (header of headers(); track $index) {
        <th class="text-start px-2 py-1">
          {{ header }}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of rows(); track $index) {
      <tr>
        @for (col of row; track $index) {
          <td class="px-2 py-1">
            {{ col }}
          </td>
        }
      </tr>
    }
  </tbody>
</table>
